import urls from "../../../../global/constants/UrlConstants";
import {
  getCallParams,
  makeCall,
} from "../../../../utils/service";

function buildMyLeadQuery(payload: any) {
  const qs = new URLSearchParams();
  qs.set("start_date", payload.start_date || "");
  qs.set("end_date", payload.end_date || "");
  qs.set("id", payload.userId || "");
  qs.set("page", String(payload.pageNo ?? 0));
  qs.set("limit", String(payload.pageSize ?? 25));
  qs.set("search", payload.search || "");
  qs.set("formId", payload.formId || "");
  qs.set("stage", payload.stage || "");
  if (payload.source) qs.set("source", payload.source);
  if (payload.assignment) qs.set("assignment", payload.assignment);
  if (payload.uploadLeadId) qs.set("uploadLeadId", payload.uploadLeadId);
  const parentStage = String(payload.parentStage || payload.type || "").trim();
  if (parentStage) qs.set("type", parentStage);
  const orgId = String(payload.organizationId || "").trim();
  if (orgId && orgId !== "all" && orgId !== "*") qs.set("organizationId", orgId);
  return qs.toString();
}

export async function getAllMyLead(payload: any) {
  try {
    const callParams = await getCallParams("GET");
    return makeCall(`${urls.MYLEAD}?${buildMyLeadQuery(payload)}`, callParams);
  } catch (error) {
    throw error;
  }
}
export async function getDateWiseLead(
  userId: string,
  from: string,
  to: string,
  pageNo: any,
  pageSize: any
) {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(
      urls.LEADDATA +
        `?start_date=${from}&end_date=${to}&id=${userId}&page=${pageNo}&limit=${pageSize}`,
      callParams
    );
    return response;
  } catch (error) {
    throw error;
  }
}
export async function getAllForms() {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(
      `${urls.GETALLLEADS}?slim=1&limit=2000`,
      callParams
    );
    return response;
  } catch (error) {
    throw error;
  }
}
export async function getAllTeam() {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(urls.GETTEAMDROP, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}
export async function getAllStage() {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(urls.GETALLSTAGE, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}
export async function getAllSource() {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(urls.GETALLSOURSE, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}
export async function getReminder(id: any) {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(`${urls.GETREMINDER}${id}`, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}

/** One slim call for all reminders (no per-lead N+1). */
export async function getReminderData() {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(
      `${urls.GETREMINDERALL}?slim=1`,
      callParams
    );
    return response;
  } catch (error) {
    throw error;
  }
}

export async function getRemark(id: any) {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(`${urls.GETREMARK}${id}`, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}
export async function postOfficeDetails() {
  try {
    const callParams = await getCallParams("POST");
    const response = await makeCall(urls.ADDUSEROFFICE, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
}

export async function changeStatusApi(status: any, userId: any) {
  const payload = {
    id: userId,
    status: status == 0 ? 1 : 0,
  };
  try {
    const callParams = await getCallParams("PUT", payload);
    const response = await makeCall(urls.USERUPDATE, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function changeStage(body: any) {
  try {
    const callParams = await getCallParams("PUT", body);
    const response = await makeCall(urls.UPDATESTAGE, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}
export async function changeAt(body: any) {
  try {
    const callParams = await getCallParams("PUT", body);
    const response = await makeCall(urls.UPDATEAI, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}
export async function saveReminder(body: any) {
  try {
    const callParams = await getCallParams("POST", body);
    const response = await makeCall(urls.UPDATEREMINDER, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function saveRemark(body: any) {
  try {
    const callParams = await getCallParams("POST", body);
    const response = await makeCall(urls.UPDATEREMARK, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function updateRemark(body: any) {
  try {
    const callParams = await getCallParams("PUT", body);
    const response = await makeCall(urls.EDITREMARK, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}
export async function assignToMembers(body: any) {
  try {
    const callParams = await getCallParams("PUT", body);
    const response = await makeCall(urls.ASSIGNTOMEMBERS, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function getAllReminder(id: any) {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(
      urls.UPDATEREMINDER + `/${id?.id}`,
      callParams
    );
    return response;
  } catch (error) {
    throw error;
  }
}
export async function getAllMyLeadContactStage(payload: any) {
  try {
    const callParams = await getCallParams("GET");
    return makeCall(
      `${urls.MYLEADCONTACT}?${buildMyLeadQuery(payload)}`,
      callParams
    );
  } catch (error) {
    throw error;
  }
}
export async function getAllMyLeadStageLead(payload: any) {
  try {
    const callParams = await getCallParams("GET");
    return makeCall(
      `${urls.MYLEADSTAGELEAD}?${buildMyLeadQuery(payload)}`,
      callParams
    );
  } catch (error) {
    throw error;
  }
}
export async function getLeadStageOpportunity(payload: any) {
  try {
    const callParams = await getCallParams("GET");
    return makeCall(
      `${urls.MYLEADSTAGEPOPPORTUNITY}?${buildMyLeadQuery(payload)}`,
      callParams
    );
  } catch (error) {
    throw error;
  }
}
export async function getLeadStageProspect(payload: any) {
  try {
    const callParams = await getCallParams("GET");
    return makeCall(
      `${urls.MYLEADSTAGEPROSPECT}?${buildMyLeadQuery(payload)}`,
      callParams
    );
  } catch (error) {
    throw error;
  }
}
export async function getLeadStageClosure(payload: any) {
  try {
    const callParams = await getCallParams("GET");
    return makeCall(
      `${urls.MYLEADSTAGECLOSURE}?${buildMyLeadQuery(payload)}`,
      callParams
    );
  } catch (error) {
    throw error;
  }
}
